import {Vue} from "vue-property-decorator";
import dayjs from "dayjs";

Vue.filter("formatDateTime", (value: any, filterFormat?: string) => {
    return value ? dayjs(value).format(filterFormat || "D/M/YYYY HH:mm") : "";
});
